import { NoteRepositoryInterface } from '@/services/QC-V2/note/interfaces';
import { NoteCreateInterface, NoteInterface } from '@/services/QC-V2/chat/interfaces';
import { AxiosInstance } from 'axios';

export default class NoteRepository implements NoteRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async createChatNote(id: string, data: NoteCreateInterface): Promise<NoteInterface> {
    const response = await this.axios.post(`/chat-controller-v2/chats/${id}/notes`, data);

    return response.data;
  }

  public async updateChatNote(chatId: string, noteId: number, data: NoteCreateInterface): Promise<void> {
    await this.axios.patch(`/chat-controller-v2/chats/${chatId}/notes/${noteId}`, data);
  }

  public async deleteChatNote(id: string, noteId: number): Promise<void> {
    await this.axios.delete(`/chat-controller-v2/chats/${id}/notes/${noteId}`);
  }

  public async createTicketNote(id: number, data: NoteCreateInterface): Promise<NoteInterface> {
    const response = await this.axios.post(`/ticket-controller-v2/tickets/${id}/notes`, data);

    return response.data;
  }

  public async updateTicketNote(ticketId: number, noteId: number, data: NoteCreateInterface): Promise<void> {
    await this.axios.patch(`/ticket-controller-v2/tickets/${ticketId}/notes/${noteId}`, data);
  }

  public async deleteTicketNote(id: number, noteId: number): Promise<void> {
    await this.axios.delete(`/ticket-controller-v2/tickets/${id}/notes/${noteId}`);
  }
}
